import { Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EMPTY, of, Subject } from 'rxjs';
import { catchError, finalize, switchMap, tap } from 'rxjs/operators';
import { PortfolioPaper } from '../../../_shared/model/portfolio/portfolioPaper.model';
import { MfToastService } from '../../../_shared/services';
import { DocumentCancelRequest } from '../../pages/home/terms/visit/crpp/_model/crpp-document-request';
import { CrppDocumentsService } from '../../pages/home/_services/crpp-documents.service';

@Component({
    selector: 'app-cancel-crpp-doc-share',
    templateUrl: './cancel-crpp-doc-share.component.html',
    styleUrls: ['./cancel-crpp-doc-share.component.scss'],
})
export class CancelCrppDocShareComponent {
    @Input() paper: PortfolioPaper;
    public reasonField = new FormControl(null, [Validators.required]);
    public isLoading$ = new Subject<boolean>();

    constructor(
        public activeModal: NgbActiveModal,
        private mfToastService: MfToastService,
        private crppDocRest: CrppDocumentsService,
    ) {}

    public onCancelClick(): void {
        if (this.reasonField.invalid) {
            this.reasonField.markAsTouched();
            return;
        }

        const data = {
            paperId: this.paper.id,
            reason: this.reasonField.value,
        } as DocumentCancelRequest;

        this.crppDocRest
            .cancelDocument(data)
            .pipe(
                switchMap(() => {
                    this.isLoading$.next(true);
                    return of(null);
                }),
                tap(() => {
                    this.mfToastService.success('Deljenje dokumenta uspešno preklicano');
                    this.paper.crppShared = false;
                    this.activeModal.close();
                }),
                finalize(() => {
                    this.isLoading$.next(false);
                }),
                catchError(() => {
                    this.mfToastService.error('Napaka pri preklicu deljenja dokumenta');
                    return EMPTY;
                }),
            )
            .subscribe();
    }
}
